/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetToolsResult } from '../../models/get-tools-result';
import { ToolType } from '../../models/tool-type';

export interface ApiToolsGet$Params {
  type?: ToolType;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiToolsGet(http: HttpClient, rootUrl: string, params?: ApiToolsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetToolsResult>> {
  const rb = new RequestBuilder(rootUrl, apiToolsGet.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetToolsResult>;
    })
  );
}

apiToolsGet.PATH = '/api/Tools';
